import * as React from 'react';
export var ZeroHunger = function (_a) {
  var className = _a.className;
  return React.createElement("svg", {
    className: className,
    width: "48",
    height: "48",
    viewBox: "0 0 472.5 604"
  }, React.createElement("g", null, React.createElement("g", null, React.createElement("g", null, React.createElement("g", {
    transform: "translate(81.000000, 65.113992)"
  }, React.createElement("path", {
    fill: "#D5A103",
    d: "M132.9,494.6v10.2c0,0.1,0,0.2,0,0.2c0,0.1,0,0.2,0,0.2c0.1,2.5,2.2,4.5,4.7,4.6h0.1h0.1\n          h119.7h0.1h0.1c2.6,0,4.7-2.2,4.7-4.8l0,0l0,0v-11.6c67.4-22.1,117.8-76.8,128.9-143.4c0-0.1,0-0.3,0.1-0.4\n          c0-0.2,0.1-0.4,0.1-0.7c0-2.7-2.2-4.8-4.8-4.8H7.5H5.3c-2.7,0-4.9,2.2-4.9,4.8l0.3,2.2C12.3,418.4,64.2,473.3,132.9,494.6"
  }), React.createElement("path", {
    fill: "#D5A103",
    d: "M262.3,181.1c-1.6,2.2-38.4,55.4,0.8,98.3c18,19.7,16.4,37.1,11.3,48.9h25.2\n          c5.1-17.3,3-39.1-17.4-61.5c-28.9-31.7,0.4-74.4,0.8-75.1c3.5-4.9,1.6-11.2-4.1-14.1C273.2,174.7,265.8,176.2,262.3,181.1"
  }), React.createElement("path", {
    fill: "#D5A103",
    d: "M198.6,328.3h25.2c5.1-17.4,3-39.1-17.5-61.5c-28.9-31.7,0.3-74.4,0.8-75.1\n          c3.4-4.9,1.6-11.1-4.1-14.1c-5.7-2.9-13.1-1.4-16.6,3.5c-1.6,2.2-38.5,55.4,0.8,98.3C205.3,299.1,203.7,316.5,198.6,328.3"
  }), React.createElement("path", {
    fill: "#D5A103",
    d: "M110.6,181.1c-1.6,2.2-38.4,55.4,0.8,98.3c18,19.7,16.4,37.1,11.3,48.9h25.2\n          c5.1-17.3,3-39.1-17.5-61.5c-28.9-31.7,0.4-74.4,0.8-75.1c3.4-4.9,1.6-11.2-4.1-14.1C121.4,174.6,114,176.2,110.6,181.1"
  }), React.createElement("path", {
    fill: "#D5A103",
    d: "M-17.1,64.5h-40.4v-6.9c0-11.4,4.1-15.8,10.4-22.5l15.7-16.6C-18.7,4.9-15.8-3.7-15.8-18.4\n          v-14.3c0-20.9-10.1-30.9-32.1-30.9c-21.6,0-32.6,11.5-32.6,32v17.7h22.4v-18.4c0-8.8,4.3-11.4,9.5-11.4c4.7,0,8.8,1.9,8.8,11\n          v12.1c0,12.1-1.1,16.9-9.1,25.3l-13.8,14.7C-76,33.6-81,43.1-81,57.6v27h63.9V64.5z"
  }), React.createElement("polygon", {
    fill: "#D5A103",
    points: "64.4,-7.3 80,-7.3 80,1.1 53.6,1.1 53.6,-7.3 69.8,-51.8 55.3,-51.8 55.3,-60.2 \n          80.6,-60.2 80.6,-51.8"
  }), React.createElement("polygon", {
    fill: "#D5A103",
    points: "86,-60.2 110.5,-60.2 110.5,-51.8 96.3,-51.8 96.3,-34.3 106.5,-34.3 106.5,-25.9 \n          96.3,-25.9 96.3,-7.3 110.5,-7.3 110.5,1.1 86,1.1"
  }), React.createElement("path", {
    fill: "#D5A103",
    d: "M126.3-51.8v19.1h3.4c3.5,0,5.1-1.8,5.1-5.1v-9c0-3.3-1.5-5-5.1-5H126.3z M126.3-27V1.1\n          H116v-61.3h15c10.4,0,14.2,5.1,14.2,13.7v7.9c0,6.6-2.3,10.5-8.2,11.8L146.8,1H136L126.3-27z"
  }), React.createElement("path", {
    fill: "#D5A103",
    d: "M171.6-13.1V-46c0-3.7-1.6-6.3-5.3-6.3c-3.6,0-5.2,2.6-5.2,6.3v32.9c0,3.7,1.6,6.3,5.2,6.3\n          C170-6.8,171.6-9.4,171.6-13.1 M150.7-14.7v-29.7c0-9.5,4.7-16.5,15.6-16.5s15.6,7,15.6,16.5v29.6c0,9.5-4.7,16.5-15.6,16.5\n          C155.4,1.8,150.7-5.3,150.7-14.7"
  }), React.createElement("polygon", {
    fill: "#D5A103",
    points: "74.6,59.8 64.6,59.8 64.6,86.8 54.4,86.8 54.4,25.6 64.6,25.6 64.6,51.5 \n          74.6,51.5 74.6,25.6 84.9,25.6 84.9,86.8 74.6,86.8"
  }), React.createElement("path", {
    fill: "#D5A103",
    d: "M120.6,25.6v46.3c0,9.5-4.1,15.6-14.5,15.6c-10.8,0-15.3-6.1-15.3-15.6V25.6h10.3v47.3\n          c0,3.6,1.4,6,5,6s5.1-2.4,5.1-6V25.6H120.6z"
  }), React.createElement("polygon", {
    fill: "#D5A103",
    points: "135.1,48.4 135.1,86.8 126.5,86.8 126.5,25.6 136.6,25.6 147.7,60.7 147.7,25.6 \n          156.2,25.6 156.2,86.8 147.2,86.8"
  }), React.createElement("path", {
    fill: "#D5A103",
    d: "M177.6,54.1h14.6v32.7h-7.4v-6.7c-1.4,4.6-4.2,7.4-9.8,7.4c-8.8,0-12.9-7-12.9-16.5V41.4\n          c0-9.6,4.6-16.5,15.4-16.5c11.4,0,14.7,6.3,14.7,15.4v5.4h-9.4v-6.2c0-3.8-1.4-6-5.1-6c-3.7,0-5.3,2.6-5.3,6.3v32.9\n          c0,3.7,1.5,6.3,5,6.3c3.3,0,5.1-1.9,5.1-5.9V62.3h-4.9L177.6,54.1L177.6,54.1z"
  }), React.createElement("polygon", {
    fill: "#D5A103",
    points: "198.1,25.6 222.6,25.6 222.6,34 208.4,34 208.4,51.5 218.5,51.5 218.5,59.8 \n          208.4,59.8 208.4,78.4 222.6,78.4 222.6,86.8 198.1,86.8"
  }), React.createElement("path", {
    fill: "#D5A103",
    d: "M238.4,34v19.1h3.4c3.5,0,5.1-1.8,5.1-5.1v-9c0-3.3-1.5-5-5.1-5H238.4z M238.4,58.7v28.1\n          h-10.3V25.6h15c10.4,0,14.2,5.1,14.2,13.7v7.9c0,6.6-2.3,10.5-8.2,11.8l9.8,27.8h-10.8L238.4,58.7z"
  }))))));
};